import useDocumentTitle from "@/hooks/useDocumentTitle";
import { SelectScanFiles } from './SelectScanFiles';
import useImportScanStore from '@modules/importScan/hook/useImportScanStore.ts';
import { FixRotation } from '@modules/fixRotation/FixRotation.tsx';
import useFixRotationStore from '@modules/fixRotation/hook/useFixRotationStore.ts';
import { UploadScan } from '@modules/importScan/UploadScan.tsx';
import { useEffect } from 'react';

export const ImportScan = () => {
  const {
    importPhase,
    setImportPhase,
    upperJawFile,
    lowerJawFile,
    setUpperJawMesh: setImportUpperJawMesh,
    setLowerJawMesh: setImportLowerJawMesh,
    reset: resetImportScan,
  } = useImportScanStore();
  const {
    lowerJawMesh,
    upperJawMesh,
    rotationPhase,
    reset: resetFixRotation,
  } = useFixRotationStore();

  useEffect(() => {
    if (rotationPhase === 'done' && upperJawMesh && lowerJawMesh) {
      setImportUpperJawMesh(upperJawMesh);
      setImportLowerJawMesh(lowerJawMesh);
      setImportPhase('upload');
    }
  }, [
    rotationPhase,
    upperJawMesh,
    lowerJawMesh,
    setImportUpperJawMesh,
    setImportLowerJawMesh,
    setImportPhase,
  ]);

  useEffect(() => {
    return () => {
      resetFixRotation();
      resetImportScan();
    };
  }, [resetFixRotation, resetImportScan]);

  if (importPhase === 'filePick') {
    useDocumentTitle("Patients - Pick scan file | fullName");
    return <SelectScanFiles />;
  }

  if (importPhase === 'rotationFix' && upperJawFile && lowerJawFile) {
    useDocumentTitle("Patients - Fix Rotation | fullName");
    return <FixRotation upperJawFile={upperJawFile} lowerJawFile={lowerJawFile} />;
  }

  if (importPhase === 'upload') {
    useDocumentTitle("Patients - Upload Scan | fullName");
    return <UploadScan />;
  }

  return null;
};
